import { appName } from "../../../core/schema/appName.js";

export function createTitle(title?: string): string {
	return title ?? appName;
}
